function myFunction() {
    var x = "Battery CAPACITY:  " + document.getElementById("myForm").elements[0].value;
    var y = "Battery MODEL:  " + document.getElementById("myForm").elements[1].value;
    var z = "Battery Price:  $" + document.getElementById("myForm").elements[2].value;
    var r = "Battery IMAGE:  " + document.getElementById("myForm").elements[3].value;
    document.getElementById("alert").innerHTML = x + y + z + r;

    alert("battery added to selling page");
}


function Sell() {



    return (
        <html lang="en">

            <head>


            </head>

            <body>
                Selling page
            </body>
            <br />
            Create a new Listing:
            <br />
            <form id="myForm" >
                <input id="cap" placeholder="Capacity" type="number"></input>
                <br />
                <input id="mod" placeholder="model"></input>
                <br />
                <input id="pri" placeholder="Price" type="number" step="0.01"></input>
                <br />


                <label for="img">Upload image:</label>
                <input type="file" id="img" name="img" accept="image/*"></input >

            </form>
            <input type="button" value="Submit" onClick={myFunction} />

            <body id="alert" style={{ border: "1px solid black", color: 'yellow' }}>  </body>









        </html>
    );
}
export default Sell;